import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import VFFLogoRed from './VFFLogoRed'
import Group from 'components/utils/Group'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextButton from 'components/Luxkit/Button/TextButton'

const Sheet = styled.div`
  display: grid;
  justify-content: center;
  grid-template:
    "logo" auto
    "." ${rem(12)}
    "content" auto
    "."  ${rem(12)}
    "button" auto;

  padding: ${rem(20)} ${rem(24)};
  background: ${(props) => props.theme.palette.neutral.default.seven};

  ${mediaQueryUp.tablet} {
    padding: ${rem(32)} ${rem(48)};
    gap: ${rem(8)} ${rem(40)};
    justify-content: start;
    grid-template:
      "logo content button" auto
      "logo content button" auto / auto 1fr ${rem(163)};
  }
`

const ButtonArea = styled(Group)`
  grid-area: button;
`

const LogoArea = styled(Group)`
  grid-area: logo;
  width: ${rem(107)};
  justify-self: center;

  ${mediaQueryUp.tablet} {
    width: ${rem(161)};
    align-self: center;
  }
`

const ContentArea = styled(Group)`
  grid-area: content;
`

function VFFJoinPromo() {
  return <Sheet>
    <LogoArea direction="vertical" horizontalAlign="center">
      <VFFLogoRed />
    </LogoArea>

    <ContentArea direction="vertical" tabletHorizontalAlign="start" tabletGap={8}>
      <Heading variant="heading5" align="center" tabletAlign="start">
        Not a Velocity Frequent Flyer member?
      </Heading>
      <BodyText variant="large" align="center" tabletAlign="start">
        It's free and fast to join Velocity. Join now to redeem Points
      </BodyText>
    </ContentArea>

    <ButtonArea direction="vertical">
      <TextButton kind="secondary" size="medium" href="https://join.velocityfrequentflyer.com/">
        Join for free
      </TextButton>
    </ButtonArea>
  </Sheet>
}

export default VFFJoinPromo
